export const name = 'stores' as const
export const Structure = Symbol('Structure')
